/**
 * Scoring Labels feature hooks — React Query wrappers for CRUD operations.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { scoreLabelsApi } from './api'

export function useEngineScoreLabels() {
    return useQuery({
        queryKey: ['score-labels'],
        queryFn: async () => {
            const res = await scoreLabelsApi.getAll()
            return res.data
        },
    })
}

export function useCreateEngineScoreLabel() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (data: any) => scoreLabelsApi.create(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['score-labels'] })
        },
    })
}

export function useUpdateEngineScoreLabel() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: ({ value, data }: { value: number; data: any }) =>
            scoreLabelsApi.update(value, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['score-labels'] })
        },
    })
}

export function useDeleteEngineScoreLabel() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (value: number) => scoreLabelsApi.delete(value),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['score-labels'] })
        },
    })
}

